(function () {

  'use strict';

  function pxInput(RegexModel) {
    return {
      restrict: 'EA',
      scope: {
        inputData: '=inputData',
        newValue: '=newValue',
        callback: '&callback'
      },
      templateUrl: 'app/directives/inputDirective/input.template.html',
      link: function (scope) {

        scope.data = scope.inputData.inputDataObject;
        const originalData = angular.copy(scope.inputData.inputDataObject);
        const BAD_STRING_NAME = new RegexModel().badNameString().regex2;
        scope.BAD_STRING_NAME = new RegexModel().badNameString().string;

        let inputValidationRequired = false;

        (function () {
          if (enableRegexValidation()) {
            badStringNameTest();
          }
        })();

        function enableRegexValidation() {
          if (scope.data[0].keyIdentifier === 'printerName' || scope.data[0].keyIdentifier === 'printerLocation') {
            inputValidationRequired = true;
            return true;
          }
          return false;
        }

        scope.$watch(function () {
          return scope.inputData;
        }, function () {
          scope.data = scope.inputData.inputDataObject;
        }, true);

        scope.$watch(function () {
          return scope.newValue;
        }, function () {
          if (scope.newValue) {
            setNewValue();
          }
        }, true);

        function setNewValue() {
          for (let i = 0; i < scope.data.length; i++) {
            if (scope.data[i].keyIdentifier === scope.newValue.keyIdentifier) {
              scope.data[i].value = scope.newValue.name;
              scope.validateInput(scope.data[i]);
            }
          }
        }

        scope.validateInput = function (input) {
          if (!badStringNameTest()) {
            if (input.value.length > 0 || input.allowEmptyInput) {
              for (let i = 0; i < originalData.length; i++) {
                if (input.keyIdentifier === originalData[i].keyIdentifier) {
                  if (input.value !== originalData[i].value) {
                    if (scope.data.length > 1) {
                      scope.callback({ input: scope.data, boolean: true });
                    } else {
                      scope.callback({ input, boolean: true });
                    }
                  } else {
                    scope.callback({ input, boolean: false });
                  }
                }
              }
            } else {
              scope.callback({ input, boolean: false });
            }
          } else {
            scope.callback({ input, boolean: false });
          }
        };

        function badStringNameTest() {
          if (!inputValidationRequired) {
            return false;
          }
          scope.data.forEach(function (input) {
            input.isInvalid = !BAD_STRING_NAME.test(input.value);
          });
          return scope.data.some(function (input) {
            return input.isInvalid;
          });
        }

        if (scope.data[0].value?.length) {
          scope.callback({ input: scope.data[0], boolean: true });
        }
      }
    };
  }

  pxInput.$inject = ['RegexModel'];

  angular
    .module('printix-admin')
    .directive('pxInput', pxInput);

})();
